// extracted by mini-css-extract-plugin
export default {"editOrder":"Order_editOrder__Yxyn0","cancelOrder":"Order_cancelOrder__vfLvf","deliveryInfo":"Order_deliveryInfo__Gi0Q2","gutter":"Order_gutter__VBkmS"};